import { Chip, CircularProgress, Dialog, DialogActions, DialogContent, Switch } from '@mui/material'
import React,{useState} from 'react'
import { useAppData } from '../../../../../context/AppDataContext'
import { Archive, CheckBox, CheckBoxOutlineBlank, CheckCircle, Delete } from '@mui/icons-material';
import calendarServices from '../calendarServices';
import { useAlert } from '../../../../../context/AlertContext';

function EventArchive({event}) {
    
    const {AppAlert} = useAlert();
    const {getCalendarEventList} = useAppData();
    const [dialogStatus,setDialogStatus] = useState(false);

    const [saving,setSavingStatus] = useState(false);

    const remove = () =>{
        setSavingStatus(true)
        calendarServices.remove(event.id).then(res=>{
            AppAlert("Removed");
            setDialogStatus(false);
            getCalendarEventList();
        }).catch(error=>{
            AppAlert("Something went Wrong! Try Again","error");
        }).finally(()=>setSavingStatus(false))

    }


    return (
        <>
            <button className='btn btn-sm btn-outline-danger' onClick={()=>setDialogStatus(true)}><Archive/> Archive</button>
             <Dialog open={dialogStatus} onClose={() => setDialogStatus(false)} fullWidth maxWidth="sm" >
                <DialogContent>
                    <div>
                        Are you sure you want to archive ?
                    </div>
                </DialogContent>
                <DialogActions>
                    <button className='btn btn-outline-dark' onClick={()=>setDialogStatus(false)} > No</button>
                    {!saving ?
                            <button className='btn btn-danger' onClick={remove} > <Delete/> Yes Confirm! </button>
                        :
                            <CircularProgress/>
                    }
                </DialogActions>
             </Dialog>
        </>
    )
}

export default EventArchive